import React from "react";
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";

const MyTabs = (props) => {
  const { orientation = "horizontal", list } = props;

  return (
    <Box
      borderRadius="xl"
      border="1px solid"
      borderColor="gray.200"
      bg={useColorModeValue("white", "gray.800")}
      boxShadow="sm"
      overflow="hidden"
    >
      <Tabs
        orientation={orientation}
        isLazy
        variant="unstyled"
        colorScheme="blue"
      >
        <TabList
          bg="gray.50"
          padding={orientation === "vertical" ? 4 : 0}
          display="flex"
          flexDirection={orientation === "vertical" ? "column" : "row"}
          borderBottom={orientation === "horizontal" ? "1px solid" : "none"}
          borderRight={orientation === "vertical" ? "1px solid" : "none"}
          borderColor="gray.200"
          gap={1}
          p={2}
        >
          {list.map((item) => (
            <Tab
              key={item?.id || item?.title}
              isDisabled={item?.isDisabled}
              fontWeight="600"
              fontSize="14px"
              width={orientation === "vertical" ? "100%" : "max-content"}
              color="gray.600"
              bg="transparent"
              borderRadius="lg"
              px={4}
              py={2.5}
              minH="44px"
              transition="all 0.2s ease"
              _hover={{
                bg: "blue.50",
                color: "blue.700",
                transform: "translateY(-1px)",
                boxShadow: "sm"
              }}
              _selected={{
                color: "white",
                bg: "linear-gradient(135deg, #4299e1 0%, #3182ce 100%)",
                boxShadow: "md",
                transform: "translateY(-1px)",
                border: "1px solid",
                borderColor: "blue.300"
              }}
              _active={{
                transform: "translateY(0px)"
              }}
              _disabled={{
                opacity: 0.5,
                cursor: "not-allowed",
                _hover: {
                  bg: "transparent",
                  transform: "none",
                  boxShadow: "none"
                }
              }}
            >
              {item?.title}
            </Tab>
          ))}
        </TabList>

        <TabPanels>
          {list.map((item) => (
            <TabPanel
              key={item.id || item.title}
              bg="white"
              p={6}
              minH="400px"
            >
              <Box as="section">
                <item.Component />
              </Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default MyTabs;
